import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { AngularMyDatePickerModule } from 'angular-mydatepicker';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { CustomHammerConfig } from './custom-hammer-config'

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);

import { setAppInjector } from './app.injector';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConnexionComponent } from './components/connexion/connexion.component';
//import { AccueilComponent } from './components/accueil/accueil.component';
import { FicheComponent } from './components/fiche/fiche.component';
import { DocumentationComponent } from './components/documentation/documentation.component';
import { HeaderComponent } from './components/header/header.component';
import { Erreur404Component } from './components/erreur/erreur404/erreur404.component';
import { ListerUtilisateurParFournisseurComponent } from './components/lister-utilisateur-par-fournisseur/lister-utilisateur-par-fournisseur.component';
import { UtilisateurParFournisseurComponent } from './components/utilisateur-par-fournisseur/utilisateur-par-fournisseur.component';
import { FournisseurInterceptor } from './interceptors/fournisseur.interceptor';
import { ReinitialiserMotDePasseComponent } from './components/reinitialiser-mot-de-passe/reinitialiser-mot-de-passe.component';
import { MessageComponent } from './components/message/message.component';
import { LoaderComponent } from './components/loader/loader.component';
import { HorairePointRelaisComponent } from './components/horaire-point-relais/horaire-point-relais.component';
import { FicheFournisseurComponent } from './components/fiche-fournisseur/fiche-fournisseur.component';
import { FicheRelaisModuleComponent } from './components/fiche-relais-module/fiche-relais-module.component';
import { FicheRelaisCalendrierComponent } from './components/fiche-relais-calendrier/fiche-relais-calendrier.component';
//import { FicheRelaisSignaletiqueComponent } from './components/fiche-relais-signaletique/fiche-relais-signaletique.component';
import { FicheRelaisPhotoComponent } from './components/fiche-relais-photo/fiche-relais-photo.component';
//import { FicheRelaisDescriptionComponent } from './components/fiche-relais-description/fiche-relais-description.component';
import { UsurpationComponent } from './components/usurpation/usurpation.component';
import { SwitchComponent } from './components/switch/switch.component';
import { ElementSignaletiqueComponent } from './components/element-signaletique/element-signaletique.component';
import { PopupComponent } from './components/popup/popup.component';
import { FacturationComponent } from './components/facturation/facturation.component';
import { RechercheFacturationComponent } from './components/recherche-facturation/recherche-facturation.component';
import { FacturesComponent } from './components/factures/factures.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { RechercheDocumentationComponent } from './components/recherche-documentation/recherche-documentation.component';
import { ListeDocumentationComponent } from './components/liste-documentation/liste-documentation.component';
import { ElementDocumentationComponent } from './components/element-documentation/element-documentation.component';
import { Erreur4031Component } from './components/erreur/erreur4031/erreur4031.component';
import { Erreur4032Component } from './components/erreur/erreur4032/erreur4032.component';
import { InfoBulleDirective } from './directives/info-bulle.directive';
import { ListerFournisseursComponent } from './components/lister-fournisseurs/lister-fournisseurs.component';
import { AdministrationComponent } from './components/administration/administration.component';
import { TableauComponent } from './components/tableau/tableau.component';
import { BoutonConfirmationComponent } from './components/bouton-confirmation/bouton-confirmation.component';
import { MessageAlertComponent } from './components/message-alert/message-alert.component';
import { ImageCropperComponent } from './components/image-cropper/image-cropper.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { InputPasswordComponent } from './components/input-password/input-password.component';
import { MotDePasseComponent } from './components/mot-de-passe/mot-de-passe.component';
import { ContactComponent } from './components/contact/contact.component';
import { ElementCampagneMarketingComponent } from './components/element-campagne-marketing/element-campagne-marketing.component';
import { RedirectComponent } from './components/redirect/redirect.component';

@NgModule({
  declarations: [
    AppComponent,
    ConnexionComponent,
    //AccueilComponent,
    FicheComponent,
    DocumentationComponent,
    HeaderComponent,
    Erreur404Component,
    ListerUtilisateurParFournisseurComponent,
    UtilisateurParFournisseurComponent,
    ReinitialiserMotDePasseComponent,
    MessageComponent,
    LoaderComponent,
    HorairePointRelaisComponent,
    FicheFournisseurComponent,
    FicheRelaisModuleComponent,
    FicheRelaisCalendrierComponent,
    //FicheRelaisSignaletiqueComponent,
    FicheRelaisPhotoComponent,
    //FicheRelaisDescriptionComponent,
    UsurpationComponent,
    SwitchComponent,
    ElementSignaletiqueComponent,
    PopupComponent,
    FacturationComponent,
    RechercheFacturationComponent,
    FacturesComponent,
    PaginationComponent,
    RechercheDocumentationComponent,
    ListeDocumentationComponent,
    ElementDocumentationComponent,
    Erreur4031Component,
    Erreur4032Component,
    InfoBulleDirective,
    ListerFournisseursComponent,
    AdministrationComponent,
    TableauComponent,
    BoutonConfirmationComponent,
    MessageAlertComponent,
    ImageCropperComponent,
    FeedbackComponent,
    InputPasswordComponent,
    MotDePasseComponent,
    ContactComponent,
    ElementCampagneMarketingComponent,
    RedirectComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    AngularMyDatePickerModule
  ],
  providers: [
      { provide: HTTP_INTERCEPTORS, useClass: FournisseurInterceptor, multi: true },
      { provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
    constructor(private injector: Injector) {
        setAppInjector(injector);
    }
}
